export default __webpack_public_path__ + "static/media/screen2.8c75990a.png";